import React from 'react';
import { CModal, CModalBody, CButton } from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { cilX, cilDelete } from '@coreui/icons';
import { setShowRelatedObjectWarningPopup } from '../../../actions/general';
import { useNavigate } from 'react-router-dom';
import { POPUP_TYPE, SYSTEM_ADMIN_PATH } from '../../../constants';

const WarningRelatedObjectPopup = ({ relatedId, object }) => {
     const dispatch = useDispatch();
     const navigate = useNavigate();
     const relatedWarningMessage = useSelector((state) => state.general.relatedWarningMessage);

     const handleCancelButtonClick = () => {
          dispatch(setShowRelatedObjectWarningPopup(null));
     };

     const handleGoToRelatedObject = () => {
          if (object === 'Product') {
               navigate(SYSTEM_ADMIN_PATH.TRAINING_PRODUCTS_DETAIL.replace(':id', relatedId));
          }
          dispatch(setShowRelatedObjectWarningPopup(null));
     };
     return (
          <>
               <CModal visible={true} alignment="center" className="remove-popup">
                    <CModalBody className="text-center">
                         <CIcon icon={cilX} className="icon-close-popup" onClick={handleCancelButtonClick}></CIcon>
                         <div className="remove-popup-icon">
                              <CIcon icon={cilDelete} className="text-danger" height={38} alt="CoreUI Icons Delete" />
                         </div>
                         <h2>Related Object Warning</h2>
                         <div className="remove-popup-description">
                              {relatedWarningMessage || `This ${object} has includes some another data still has been used.`}
                         </div>
                         <div className="mb-3">
                              {relatedId && relatedId !== POPUP_TYPE.WARNING_RELATED && (
                                   <CButton className="btn-square btn-border" onClick={handleGoToRelatedObject}>
                                        Go To Related {object}
                                   </CButton>
                              )}
                              <CButton className="d-inline-block btn-cancel" color="link" onClick={handleCancelButtonClick}>
                                   Cancel
                              </CButton>
                         </div>
                    </CModalBody>
               </CModal>
          </>
     );
};

WarningRelatedObjectPopup.propTypes = {
     object: PropTypes.string,
};

export default WarningRelatedObjectPopup;
